import React, { useState, useEffect, useRef } from "react";
import "./UserDayAttendance.css";
import { connect } from "react-redux";
import uiActions from "../../../../../redux/ui/action";
import authActions from "../../../../../redux/auth/action";
import userPreferenceActions from "../../../../../redux/user_preference/action";

import "@fortawesome/fontawesome-free/css/all.min.css";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import { format, addDays, subDays } from "date-fns";
import axios from "axios";
import images from "../../../../../utilities/images/images";
import StudentDayAttendanceContent from "../../../../../parent/user-attendance/dayWiseAttendance/StudentDayAttendanceContent";
import LoaderPopUp from "../../../../../components/loader/loader";

const UserDayAttendance = (props) => {
  let { startLoading, finishLoading, rollNo,loader } = props;
  const [attendanceData, setAttendanceData] = useState({});
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [dateRange, setDateRange] = useState([]);
  const [visibleButtons, setVisibleButtons] = useState(11);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const datePickerRef = useRef(null);

  useEffect(() => {
    generateDateRange(selectedDate);
    updateVisibleButtons();
    window.addEventListener("resize", updateVisibleButtons);
    return () => window.removeEventListener("resize", updateVisibleButtons);
  }, []);

  useEffect(() => {
    generateDateRange(selectedDate);
    getDayAttendanceDetails();
  }, [selectedDate]);

  const getDayAttendanceDetails = async () => {
    const formattedDate = format(new Date(selectedDate), "yyyy-MM-dd");
    const payload = {
      startDate: formattedDate,
      endDate: formattedDate,
      rollNo: rollNo,
    };

    startLoading();

    try {
      const response = await axios.post(
        "https://bg.mescray001.com/api/v1/zoom-attendance/get-student-attendance-datewise-mla",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200 && response.data) {
        setAttendanceData(response.data);
      } else {
        setAttendanceData({});
      }
    } catch (error) {
      console.error("API Error:", error);
      setAttendanceData({});
    } finally {
      finishLoading();
    }
  };

  const generateDateRange = (date) => {
    const selectedDateObj = new Date(date);
    const startDate = subDays(selectedDateObj, 5);
    const range = Array.from({ length: 11 }, (_, i) => addDays(startDate, i));
    setDateRange(range);
  };

  const updateVisibleButtons = () => {
    const width = window.innerWidth;
    setVisibleButtons(width <= 768 ? 5 : 11);
  };

  const handleDateClick = (date) => setSelectedDate(date);
  const handleDateChange = (date) => {
    setSelectedDate(date);
    setShowDatePicker(false);
  };
  const handleClickOutside = (e) => {
    if (datePickerRef.current && !datePickerRef.current.contains(e.target)) {
      setShowDatePicker(false);
    }
  };

  return (
    <>
      <div className="student-activity-wrapper" onClick={handleClickOutside}>
        <div className="container_grey_box">
          <div className="bckBtn-title">
            <Link className="backBtn" to="/dashboard">
              <img src={images.m2_backBtn} alt="backBtn" />
            </Link>
            <div className="content-head">
              <h1>Student Attendance</h1>
              <div className="right">
                <img
                  src={images.calender}
                  alt="Choose the Date"
                  className="calendar-icon"
                  onClick={() => setShowDatePicker(!showDatePicker)}
                />
                <span className="text">Change Date</span>
                {showDatePicker && (
                  <div className="datepicker-container" ref={datePickerRef}>
                    <DatePicker
                      selected={new Date(selectedDate)}
                      onChange={handleDateChange}
                      dateFormat="dd/MM/yyyy"
                      maxDate={new Date()}
                      inline
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="date-range">
            {dateRange.slice(0, visibleButtons).map((date, index) => (
              <button
                key={index}
                onClick={() => handleDateClick(date)}
                className={
                  selectedDate.toDateString() === date.toDateString()
                    ? "active"
                    : ""
                }
              >
                {format(date, "dd MMM")}
              </button>
            ))}
          </div>
          <StudentDayAttendanceContent
            attendanceData={attendanceData}
            selectedDate={selectedDate}
          />
        </div>
      </div>
      {loader && <LoaderPopUp/>}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    loader: state.ui.loader,
    token: state.auth.authToken,
    tokenType: state.auth.authType,
    currentRefundPackage: state.RefundPackageSliceReducer.refundCurrentPackage,
    rollNo: state.auth.user.roll_no,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    startLoading: () => {
      dispatch(uiActions.startLoading());
    },
    finishLoading: () => {
      dispatch(uiActions.finishLoading());
    },
    setUser: (payload) => {
      dispatch(authActions.setUser(payload));
    },
    setUserPreference: (payload) => {
      dispatch(userPreferenceActions.setUserPreference(payload));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserDayAttendance);
